import i18next from 'i18next';

i18next.addResources('es_CL', 'PurchaseSuccess', {
  title: 'Compra exitosa',
  message: 'Felicidades! Tu pedido estará listo en un momento.',
  button: 'Hacer seguimiento'
});
